import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'

export class SearchFilterItem extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            active: false
        }

        _.bindAll(this,
            'clickHandler'
        )
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.activeFilters !== prevProps.activeFilters) {
            if (this.props.item !== this.props.activeFilters) {
                this.setState({active: false})
            }
        }
    }

    clickHandler() {
        if (this.state.active) {
            this.setState({active: false}, function() {
                this.props.removeFilter(this.props.item)
            })
        } else {
            this.setState({active: true}, function() {
                this.props.addFilter(this.props.item)
            })
        }
    }

    render() {
        let classes = this.state.active ? 'active' : ''
        return <div className={classes} onClick={() => this.clickHandler()} >{this.props.item.replace(/_/g, ' ')}</div>
    }
}
